import React from "react";
import { useAppSelector } from "../../../store/hooks";
import { selectDirection } from "../../../store/selectors/appSelectors";
import Button from "../../Button/Button";
import { A, H1, H2, P } from "../../Text/Text";

const Splashscreen = ({ tourName, handleStart, handleSkip }) => {
  const dir = useAppSelector(selectDirection);
  return (
    <div className="product-tour-overlay" dir={dir}>
      <div className="tour-splash">
          <div className="logo">
            <H1 className="tutorial-header">tutorial welcome message</H1>
          </div>
        <H2>tutorial welcome title</H2>
        <P>tutorial welcome text</P>
        <div className="control-buttons">
          <Button
            onClick={handleStart}
          >
            tutorial welcome proceed
          </Button>
          <A onClick={handleSkip} className="skip-a-tour">
            tutorial welcome skip
          </A>
        </div>
      </div>
    </div>
  );
};

export default Splashscreen;
